import React from "react";
import { Row, Col, Button, Card, Checkbox, Radio, Modal } from "antd";
import Scrollbars from "react-custom-scrollbars";
import { MinusOutlined, PlusOutlined } from "@ant-design/icons";
import removeBg from "../../../../assets/images/removebg.png";
import data from "../../../../constants/restaurantPos.json";
import { getMultilingualText } from "../../../../utils/getMultilingualText";
import groupBy from "lodash/groupBy";

const AddOnSelectionModal = ({
  layout,
  displayAddOnSelection,
  handleAddOnModalClose,
  selectedProduct,
  currenciesList,
  handleQty,
  addOnsList,
  selectedAddons,
  handleAddOnValue,
  updateAddonQty,
  handleAdd,
}) => {
  return (
    <Modal
      closable={false}
      footer={null}
      styles={{ body: {
        padding: 16,
        background: "#fff",
        height: "60vh",
        display: "flex",
        flexDirection: "column",
      } }}
      open={layout === "2" && displayAddOnSelection}
      onCancel={handleAddOnModalClose}
      centered
      width={"32%"}
    >
      <Row
        style={{
          padding: "6px 8px",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Col>
          <img src={removeBg} style={{ height: "2vh", marginRight: 6 }} />
          <span style={{ fontSize: "1.2em", fontWeight: 600 }}>{selectedProduct?.name}</span>
        </Col>

        <Col>
          <span style={{ fontSize: "1.2em", fontWeight: 600 }}>
            {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
            {selectedProduct?.sunitprice}
            {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
          </span>
        </Col>
      </Row>
      <Row
        style={{
          alignItems: "center",
          justifyContent: "space-between",
          margin: "8px 5px",
        }}
      >
        <Col>
          <p style={{ fontSize: "1.2em", fontWeight: 600, margin: 0 }}>{getMultilingualText("Add On's")}</p>
        </Col>

        <Col style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <Button icon={<MinusOutlined />} style={{ width: 25, height: 25 }} onClick={() => handleQty("minus")} />

          <span style={{ fontSize: "1.2em", fontWeight: 600 }}>{selectedProduct?.weight || 1}</span>

          <Button icon={<PlusOutlined style={{ color: "#fff" }} />} style={{ width: 25, height: 25, background: "#2F3856" }} onClick={() => handleQty("plus")} />
        </Col>
      </Row>
      <div style={{ flex: 1, overflow: "hidden" }}>
        <Scrollbars autoHide style={{ height: "100%" }}>
          <Row>
            <Col span={24} style={{ paddingRight: 3, paddingBottom: 10 }}>
              <Card styles={{ body: { padding: 5 } }} style={data.restaurantPos.content.addOnSelectionModal.mainCard}>
                {/* Required Add-Ons */}
                {addOnsList?.requiredList?.length > 0 &&
                  Object.entries(groupBy(addOnsList.requiredList, (a) => a.mAddonGroup.mAddonGroupId)).map(([groupId, items]) => {
                    const groupInfo = items[0].mAddonGroup;
                    const max = groupInfo.maxqty;
                    if (max === 0) return null;
                    const selectedGroupItems = selectedAddons.filter((a) => a.mAddonGroup.mAddonGroupId === groupId);

                    return (
                      <div key={groupId}>
                        <p style={{ fontWeight: 600, margin: "6px 0" }}>{groupInfo.name}</p>

                        {max === 1 ? (
                          <Radio.Group value={selectedGroupItems[0]} onChange={(e) => handleAddOnValue(e, "addOnRadio")} style={{ width: "100%" }}>
                            {items.map((item) => (
                              <Card key={item.mProductAddOnId} styles={{ body: { padding: 10 } }}>
                                <Radio value={item}>{item?.productAliasName ? item?.productAliasName : item.name}</Radio>
                              </Card>
                            ))}
                          </Radio.Group>
                        ) : (
                          items.map((item) => {
                            const existing = selectedAddons.find((a) => a.mProductAddOnId === item.mProductAddOnId);

                            const checked = !!existing;
                            const qty = existing?.qty || 0;

                            return (
                              <Card key={item.mProductAddOnId} styles={{ body: { padding: 10 } }}>
                                <Row justify="space-between" align="middle">
                                  <Col>
                                    <Checkbox
                                      checked={checked}
                                      onChange={(e) => {
                                        if (e.target.checked) {
                                          updateAddonQty(item, 1);
                                        } else {
                                          updateAddonQty(item, -999);
                                        }
                                      }}
                                    >
                                      {item?.productAliasName ? item?.productAliasName : item.name}
                                    </Checkbox>
                                  </Col>

                                  {checked && item.mAddonGroup.allowQtySelection === "Y" && (
                                    <Col>
                                      <Button size="small" onClick={() => updateAddonQty(item, -1)} disabled={qty <= 1}>
                                        -
                                      </Button>

                                      <span style={{ margin: "0 10px" }}>{qty}</span>

                                      <Button size="small" onClick={() => updateAddonQty(item, +1)}>
                                        +
                                      </Button>
                                    </Col>
                                  )}
                                </Row>
                              </Card>
                            );
                          })
                        )}
                      </div>
                    );
                  })}
                {addOnsList?.optionsList?.length > 0 &&
                  Object.entries(groupBy(addOnsList.optionsList, (a) => a.mAddonGroup.mAddonGroupId)).map(([groupId, items]) => {
                    const groupInfo = items[0].mAddonGroup;
                    const max = groupInfo.maxqty;

                    if (max === 0) return null;

                    return (
                      <div key={groupId}>
                        <p style={{ fontWeight: 600, margin: "6px 0" }}>{groupInfo.name}</p>

                        {items.map((item) => {
                          const existing = selectedAddons.find((a) => a.mProductAddOnId === item.mProductAddOnId);

                          const checked = !!existing;
                          const qty = existing?.qty || 0;

                          return (
                            <Card key={item.mProductAddOnId} styles={{ body: { padding: 10 } }}>
                              <Row justify="space-between" align="middle">
                                <Col>
                                  <Checkbox
                                    checked={checked}
                                    onChange={(e) => {
                                      if (e.target.checked) {
                                        updateAddonQty(item, +1);
                                      } else {
                                        updateAddonQty(item, -999);
                                      }
                                    }}
                                  >
                                    {item?.productAliasName ? item?.productAliasName : item.name}
                                  </Checkbox>
                                </Col>

                                {checked && item.mAddonGroup.allowQtySelection === "Y" && (
                                  <Col>
                                    <Button size="small" onClick={() => updateAddonQty(item, -1)} disabled={qty <= 1}>
                                      -
                                    </Button>

                                    <span style={{ margin: "0 10px" }}>{qty}</span>

                                    <Button size="small" onClick={() => updateAddonQty(item, +1)}>
                                      +
                                    </Button>
                                  </Col>
                                )}
                              </Row>
                            </Card>
                          );
                        })}
                      </div>
                    );
                  })}
              </Card>
            </Col>
          </Row>
        </Scrollbars>
      </div>

      <Row style={{ marginTop: 10 }}>
        <Col span={24} style={{ fontSize: "1vw" }}>
          <Button style={data.restaurantPos.content.orderCart.checkoutBtn} className="addButton" onClick={handleAdd}>
            <span style={data.restaurantPos.content.orderCart.checkoutBtn.label}>{getMultilingualText("Add to Cart")}</span>
          </Button>
        </Col>
      </Row>
    </Modal>
  );
};

export default React.memo(AddOnSelectionModal);
